<template>
  <div class="MainSiteNavMobile">
    <div class="mobileNav" :class="openMenus.length > 0 && 'isOpen'">
      <Navbar
        :homepagePath="content.homepagePath"
        v-bind="{ toggleMenu, isMenuShowing }"
      />
      <div class="menuBackdrop">
        <div class="menuContainer">
          <TopMenuPane v-bind="{ content, openMenus, triggerCta }" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import bodyScroll from '~/lib/bodyScroll.js'

import Navbar from './Navbar.vue'
import TopMenuPane from './TopMenuPane.vue'

export default {
  components: {
    Navbar,
    TopMenuPane,
  },
  props: {
    content: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      openMenus: [],
    }
  },
  computed: {
    isMenuShowing() {
      return this.openMenus.length > 0;
    },
  },
  methods: {
    showMenu() {
      bodyScroll.lock()
      this.openMenus = ['TOP']
    },
    hideMenu() {
      bodyScroll.unlock()
      this.openMenus = []
    },
    toggleMenu() {
      this.isMenuShowing ? this.hideMenu() : this.showMenu();
    },
    triggerCta() {
      const { action, text } = this.content.cta;
      this.hideMenu();
      this.$pageActions.dispatch(action, text);
    },
  },
}
</script>

<style scoped>

.MainSiteNavMobile {
  --navbar-height: 70px;
  --menu-hairline-color: #E2E1E1;
  --menu-text-color-light: #9CA3AB;
  --menu-text-color-dark: #0F2D4C;
  --menu-transition-time: 0.2s;
  height: var(--navbar-height);
}

.mobileNav {
  z-index: 100;
}

.mobileNav.isOpen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.menuBackdrop {
  background-color: transparent;
  padding-left: calc(var(--gutter-width) + 2rem);
  transition: background-color var(--menu-transition-time);
}

.mobileNav.isOpen .menuBackdrop {
  background-color: rgba(0, 0, 0, .75);
  height: calc(100% - var(--navbar-height));
}

.menuContainer {
  position: relative;
  height: 100%;
  overflow-x: hidden;
}
</style>
